export default "__VITE_ASSET__BrzN2fS6__"